module.exports = __webpack_public_path__ + "static/img/bg_01.7251b25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/top/bg_01.jpg
// module id = 2eui
// module chunks = 1